import React from 'react';
import {FlatList, Linking, View} from 'react-native';

import ContentView from '../../components/ui-controls/layout/ContentView';
import Text from '../../components/ui-controls/Text';
import {GetDepartmentLinesSortOptionId} from '../../transport/apiService';

const Link = ({url}: {url: string}) => (
  <Text style={{color: 'blue'}} onPress={() => Linking.openURL(url)}>
    {url}
  </Text>
);

const HelpItem = ({
  title,
  fieldName,
  fieldValue,
  baseUrl,
}: {
  title: string;
  fieldName: string;
  fieldValue: string;
  baseUrl: string;
}) => (
  <View>
    <Text variant={'heading3'}>{title}</Text>
    <Link url={`${baseUrl}?${fieldName}=${fieldValue}`} />
  </View>
);

type BeerBoardHelpProps = {
  baseUrl: string;
};
const BeerBoardHelp = ({baseUrl}: BeerBoardHelpProps) => {
  return (
    <ContentView>
      <Text variant={'heading1'}>🍻 Beer Board Help</Text>
      <View style={{width: '100%', height: 10}} />
      <Text variant={'heading2'}>🍺 Sort Options (sort)</Text>
      <FlatList
        data={Object.values(GetDepartmentLinesSortOptionId)}
        renderItem={({item}) => (
          <HelpItem
            title={item}
            fieldName="sort"
            baseUrl={baseUrl}
            fieldValue={item}
          />
        )}
      />
      <Text variant={'heading2'}>🍺 Filters (filter)</Text>
      <FlatList
        data={['specials_only' as const]}
        renderItem={({item}) => (
          <HelpItem
            title={item}
            fieldName="filter"
            baseUrl={baseUrl}
            fieldValue={item}
          />
        )}
      />
      <Text variant={'heading2'}>🍺 Utils</Text>
      <FlatList
        data={[
          {
            fieldName: 'productsPerPage',
            fieldValue: '14',
          },
          {
            fieldName: 'dwellTime',
            fieldValue: '20',
          },
        ]}
        renderItem={({item}) => (
          <HelpItem
            title={item.fieldName}
            fieldName={item.fieldName}
            baseUrl={baseUrl}
            fieldValue={item.fieldValue}
          />
        )}
      />
    </ContentView>
  );
};

export default BeerBoardHelp;
